const PremiseUserAttendance = {
    premiseUserAttendance: "Premise User Attendance",
    subtitle: "Track daily premise staff attendance and mark status quickly.",
    calendarTitle: "Premise User Attendance Calendar",
    calendarSubtitle: "View monthly attendance by premise user.",
    month_year: "Month & Year",
    empty: "No Premise Staff Found.",
    search: "Search",
    date: "Date",
    role: "Role",
    premise: "Premise",
    premise_user: "Premise User",
    present: "Present",
    absent: "Absent",
    pending: "Pending",
    attendance_percentage: "Attendance %",
    pay_slip: "Pay Slip",
    view_pay_slip: "View",
    calendar_select_filters: "Select premise user, then apply filters to view the calendar.",
    notMarked: "Not marked",
    attendance_marked: "Attendance Marked Successfully.",
    table_date: "DATE",
    table_role: "ROLE",
    table_premise: "PREMISE",
    table_status: "STATUS",
}

export default PremiseUserAttendance;